
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './index.css';
// import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';
// import './styles/overrides.css';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // Unregister service worker for OAuth flows
// if (window.location.pathname.includes('/api/integrations/')) {
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.getRegistrations().then(registrations => {
//       registrations.forEach(reg => reg.unregister());
//     });
//   }
// }

// /**
//  * CRITICAL FIX FOR iOS PWA SUPPORT
//  * 
//  * Changed from unregister() to register() to enable PWA functionality
//  * on all iOS devices. This enables:
//  * - Offline support
//  * - Add to Home Screen functionality
//  * - Splash screens on iOS
//  * - Push notifications (where supported)
//  * - Faster load times through caching
//  */
// serviceWorkerRegistration.register({
//   onSuccess: (registration) => {
//     console.log('PWA registered successfully. App can now work offline!');
//   },
//   onUpdate: (registration) => {
//     console.log('New version available! Please refresh to update.');
//     // Optional: Show a toast or notification to user about the update
//     // You can implement a custom update notification here
//   }
// });

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tailwind-components.css';
// Side-effect: installs the global axios interceptor that attaches the
// JWT from localStorage to every outgoing request and routes 401 → /login.
// MUST be imported before App so the interceptor is in place by the time
// any component's effect fires its first request.
import './api/axiosBoot';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './styles/overrides.css';
// Contrast-safe surface primitives (.surface / .note / .surface-muted).
// Generalised from SuperAdminDashboard's .sa-panel/.sa-note pattern; see the
// header of surfaces.css for the rule they encode.
import './styles/surfaces.css';
import './styles/ios-pwa-fixes.css';
import './styles/desktop.css';
import './styles/articleTemplates.css';
import './styles/eventHistoryEditor.css';

// Apply the saved theme before React mounts so the first paint already
// reflects the user's preference (light / dark / minimal / system). Minimal
// is the app-wide default when the user has not picked one yet.
(function applyInitialTheme() {
  try {
    const raw = localStorage.getItem('userSettings');
    const theme = raw ? (JSON.parse(raw).theme || 'minimal') : 'minimal';
    const root = document.documentElement;
    root.classList.remove('theme-light', 'theme-dark', 'theme-minimal');
    if (theme === 'light') {
      root.classList.add('theme-light');
    } else if (theme === 'dark') {
      root.classList.add('theme-dark');
    } else if (theme === 'system') {
      const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
      root.classList.add(prefersDark ? 'theme-dark' : 'theme-light');
    } else {
      root.classList.add('theme-minimal');
    }
  } catch { /* ignore */ }
})();

// Chromium fires beforeinstallprompt once, often before the /about page has
// mounted. Hold onto it so useInstallPrompt can offer one-tap install later.
// Chrome's own mini-infobar is only suppressed on /about, which has its own
// install UI — every other route keeps the browser's default prompt.
window.addEventListener('beforeinstallprompt', (e) => {
  if (/^\/about\/?$/.test(window.location.pathname)) e.preventDefault();
  window.__onscreenInstallPrompt = e;
});

// Lock orientation to portrait where the browser supports it. Manifest
// covers installed Android PWAs; this covers Chrome/Edge in standalone.
// iOS Safari rejects the call — handled visually by the CSS overlay in
// ios-pwa-fixes.css.
Promise.resolve(window.screen?.orientation?.lock?.('portrait')).catch(() => {});

// Inject the landscape "rotate to portrait" overlay at runtime rather than
// shipping it in index.html. Keeping it out of the static shell means
// crawlers, link unfurlers, and no-JS visitors never see the rotate text
// as page content. Visibility is still driven by the CSS media query in
// ios-pwa-fixes.css (phone-sized viewports in landscape only).
//
// The portrait lock is an in-app constraint, so it's skipped on the public
// marketing/auth pages — those are responsive and fine to read in landscape.
(function injectOrientationOverlay() {
  const PUBLIC_PREFIXES = [
    '/', '/about', '/about-me', '/shops', '/pricing', '/login', '/owneradd',
    '/termsofuse', '/privacypolicy', '/sendemail',
  ];
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (PUBLIC_PREFIXES.includes(path)) return;
  if (document.getElementById('orientation-lock-overlay')) return;
  const overlay = document.createElement('div');
  overlay.id = 'orientation-lock-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML =
    '<div class="rotate-icon">↻</div>' +
    '<div class="rotate-text">Please rotate your device to portrait to use On-Screen.</div>';
  document.body.appendChild(overlay);
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister service worker for OAuth flows
if (window.location.pathname.includes('/api/integrations/')) {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(reg => reg.unregister());
    });
  }
}

/**
 * CRITICAL FIX FOR iOS PWA SUPPORT
 * 
 * Changed from unregister() to register() to enable PWA functionality
 * on all iOS devices. This enables:
 * - Offline support
 * - Add to Home Screen functionality
 * - Splash screens on iOS
 * - Push notifications (where supported)
 * - Faster load times through caching
 */
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('PWA registered successfully. App can now work offline!');
  },
  onUpdate: (registration) => {
    console.log('New version available! Please refresh to update.');
  }
});

// Unregister any stale firebase-messaging service worker that may
// have been registered by a previous deployment. It conflicts with
// the main service worker's push notification handling.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => {
      if (reg.active && reg.active.scriptURL.includes('firebase-messaging-sw')) {
        reg.unregister().then(() => {
          console.log('Unregistered stale firebase-messaging service worker');
        });
      }
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();